<template>
  <div class="layout">
    <div style="margin-bottom: 20px;">
      <van-search v-model="basicForm.likeName" placeholder="请输入会议名称" @input="onSearchChange" />
      <van-cell-group v-if="meetData.length > 0 && chooseFlag">
        <van-cell :value="item.name" v-for="(item, index) in meetData" :key="index" @click="
        confirmChoose(item.code, item.name)" />
      </van-cell-group>
      <!-- <van-field v-model="form.meetingCode" border readonly name="展会名称" is-link label="展会名称" right-icon placeholder="请选择展会名称" @click="chooseExhibition " /> -->
    </div>

    <div>
      <div class="layout_chidT">新老用户访问趋势</div>
      <div style="margin-bottom: 20px; margin-left: -30px;">
        <chart-block ref="chart"></chart-block>
      </div>

      <div v-show="form.meetingCode">
        <div class="layout_chidT">报名用户数据概览</div>
        <van-row class="order-card1-content" type="flex">
          <van-col :span="item.colCount" style="padding: 20px 0px;" v-for="(item, index) in enrollUserData" :key="index">
            <p style="margin-bottom: 6px;">{{ item.name }}</p>
            <h1>
              <count-to :decimals="item.countConfig.decimals" :duration="item.countConfig.duration" :end-val="item.countConfig.endVal" :prefix="item.countConfig.prefix" :separator="item.countConfig.separator" :start-val="item.countConfig.startVal" :suffix="item.countConfig.suffix" />
            </h1>

          </van-col>
        </van-row>

        <div class="layout_chidT" style="margin-top: 10px;">签到用户数据概览</div>
        <van-row class="order-card1-content">
          <div v-for="(item, index) in signUserData" :key="index">
            <van-col :span="item.colCount" style="padding: 20px 0;">
              <p style="margin-bottom: 6px;">{{ item.name }}</p>
              <h1>
                <count-to :decimals="item.countConfig.decimals" :duration="item.countConfig.duration" :end-val="item.countConfig.endVal" :prefix="item.countConfig.prefix" :separator="item.countConfig.separator" :start-val="item.countConfig.startVal" :suffix="item.countConfig.suffix" />
              </h1>
            </van-col>
          </div>
        </van-row>

        <div class="layout_chidT" style="margin-top: 10px;">用户互动数据概览</div>
        <van-row class="order-card1-content">
          <div v-for="(item, index) in interactionUserData" :key="index">
            <van-col :span="item.colCount" style="padding: 20px 0;">
              <p style="margin-bottom: 6px;">{{ item.name }}</p>
              <h1>
                <count-to :decimals="item.countConfig.decimals" :duration="item.countConfig.duration" :end-val="item.countConfig.endVal" :prefix="item.countConfig.prefix" :separator="item.countConfig.separator" :start-val="item.countConfig.startVal" :suffix="item.countConfig.suffix" />
              </h1>
            </van-col>
          </div>
        </van-row>

        <div class="layout_chidT" style="margin-top: 10px;">嘉宾数据概览</div>
        <van-row class="order-card1-content">
          <div v-for="(item, index) in guestData" :key="index">
            <van-col :span="item.colCount" style="padding: 20px 0;">
              <p style="margin-bottom: 6px;">{{ item.name }}</p>
              <h1>
                <count-to :decimals="item.countConfig.decimals" :duration="item.countConfig.duration" :end-val="item.countConfig.endVal" :prefix="item.countConfig.prefix" :separator="item.countConfig.separator" :start-val="item.countConfig.startVal" :suffix="item.countConfig.suffix" />
              </h1>
            </van-col>
          </div>
        </van-row>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>

</template>

<script>
import _ from 'lodash'
const colorList = ['#9E87FF', '#05A64C', '#fe9a8b', '#F56948', '#9E87FF']
import { getPlatformAllMeet, getPlatformData } from '../../../api/workBenchApi'
export default {
  name: 'singleExhibitionData',
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        meetingCode: '',
      },
      basicForm: {
        meetingType: 'EXHIBITION',
        likeName: '',
      },
      chooseFlag: false,
      meetData: [],
      // 报名用户数据
      enrollUserData: [
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '累计报名用户数',
          colCount: 24,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '老用户数量',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '%',
            separator: ',',
            duration: 3000,
          },
          name: '老用户占比',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '新用户数量',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 100),
            decimals: 0,
            prefix: '',
            suffix: '%',
            separator: ',',
            duration: 3000,
          },
          name: '新用户占比',
          colCount: 12,
        },
      ],
      // 签到用户数据
      signUserData: [
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '累计签到用户数',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '%',
            separator: ',',
            duration: 3000,
          },
          name: '签到占比',
          colCount: 12,
        },
      ],
      // 用户互动数据
      interactionUserData: [
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '次',
            separator: ',',
            duration: 3000,
          },
          name: '展览提问数量',
          colCount: 12,
        },
        // {
        //   countConfig: {
        //     startVal: 0,
        //     endVal: 0,
        //     decimals: 0,
        //     prefix: '',
        //     suffix: '次',
        //     separator: ',',
        //     duration: 3000,
        //   },
        //   name: '文件查看次数',
        //   colCount: 12,
        // },
        // {
        //   countConfig: {
        //     startVal: 0,
        //     endVal: 0,
        //     decimals: 0,
        //     prefix: '',
        //     suffix: '次',
        //     separator: ',',
        //     duration: 3000,
        //   },
        //   name: '文件下载次数',
        //   colCount: 12,
        // },
        // {
        //   countConfig: {
        //     startVal: 0,
        //     endVal: 0,
        //     decimals: 0,
        //     prefix: '',
        //     suffix: '次',
        //     separator: ',',
        //     duration: 3000,
        //   },
        //   name: '用户分享次数',
        //   colCount: 12,
        // },
      ],
      // 嘉宾用户数据
      guestData: [
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '展览嘉宾数量',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '份',
            separator: ',',
            duration: 3000,
          },
          name: '嘉宾累计上传文件数量',
          colCount: 12,
        },
      ],
      option2: {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'z-index:1',
          // formatter: (params) => {
          //   console.log(params)
          // },
        },
        grid: {
          top: '4%',
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#DCE2E8',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 3,
              color: '#556677',
              fontSize: 9,
              margin: 15,
              showMinLabel: true,
              showMaxLabel: false,
              rotate: -15,
              width: 20,
            },
            axisPointer: {
              label: {
                padding: [0, 0, 10, 0],
                margin: 15,
                fontSize: 12,
                backgroundColor: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#fff',
                    },
                    {
                      offset: 0.86,
                      color: '#fff',
                    },
                    {
                      offset: 0.86,
                      color: '#33c0cd',
                    },
                    {
                      offset: 1,
                      color: '#33c0cd',
                    },
                  ],
                  global: false,
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: 'value',
            show: false,
          },
        ],
        series: [
          {
            name: '新用户报名数量',
            type: 'line',
            data: [],
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            tooltip: {},
            lineStyle: {
              width: 2,
              shadowColor: 'rgba(115,221,255, 0.3)',
              shadowBlur: 10,
              shadowOffsetY: 20,
            },
            itemStyle: {
              color: colorList[1],
              borderColor: colorList[1],
            },
          },
          {
            name: '老用户报名数量',
            type: 'line',
            data: [],
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            tooltip: {},
            lineStyle: {
              width: 2,
              shadowColor: 'rgba(115,221,255, 0.3)',
              shadowBlur: 10,
              shadowOffsetY: 20,
            },
            itemStyle: {
              color: colorList[0],
              borderColor: colorList[0],
            },
          },
        ],
      },
      columns: ['数贸会', 'ADM展', '西博会'],
      showPicker: false,
    }
  },
  mounted() {
    this.$refs.chart.setOption(this.option2)
  },
  methods: {
    onSearchChange(e) {
      this.getAllExhibition(e)
      this.chooseFlag = true
    },
    confirmChoose(code, name) {
      this.getData(code)
      this.form.meetingCode = code
      this.chooseFlag = false
      this.basicForm.likeName = name
    },
    async getAllExhibition(likeName) {
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.token,
        // Authorization: `4415deafcdfd4e72a49c4d20bb48b657`,
      }
      const { data } = await getPlatformAllMeet(headers, {
        meetingType: 'HOLD_MEETING',
        likeName: likeName,
      })
      this.meetData = data.filter((v) => v.name != null)
      console.log(this.meetData)
    },
    chooseExhibition() {
      this.showPicker = true
    },
    // 用户自主选择
    onConfirm(e) {
      console.log(e)
      this.showPicker = false
      this.form.meetingCode = e
      this.getData()
    },

    async getData(val) {
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.token,
        // Authorization: `4415deafcdfd4e72a49c4d20bb48b657`,
      }
      const { data } = await getPlatformData(headers, {
        exhibitionCode: '',
        meetingCode: val,
      })
      this.meetingChartVo = data.meetingChartVo
      // 处理X轴时间戳
      if (this.meetingChartVo.newUserChartVos) {
        const _dateArr = this.meetingChartVo.newUserChartVos.map((v) => {
          return v.date
        })
        const _newUserData = this.meetingChartVo.newUserChartVos.map((v) => {
          return v.count
        })
        const _oldUserData = this.meetingChartVo.oldUserChartVos.map((v) => {
          return v.count
        })
        console.log(Math.floor(this.meetingChartVo.newUserChartVos.length / 4))
        this.option2.xAxis[0].data = _dateArr
        this.option2.xAxis[0].axisLabel.interval = Math.floor(this.meetingChartVo.newUserChartVos.length / 6)
        this.option2.series[0].data = _newUserData
        this.option2.series[1].data = _oldUserData
      } else {
        this.option2.xAxis[0].data = []
        this.option2.xAxis[0].axisLabel.interval = 0
        this.option2.series[0].data = []
        this.option2.series[1].data = []
      }

      // 报名用户数据
      this.enrollUserData[0].countConfig.endVal = this.meetingChartVo.attendCount
      this.enrollUserData[1].countConfig.endVal = this.meetingChartVo.attendOldUserCount
      this.enrollUserData[2].countConfig.endVal = this.meetingChartVo.attendOldUserProportion
      this.enrollUserData[3].countConfig.endVal = this.meetingChartVo.attendNewUserCount
      this.enrollUserData[4].countConfig.endVal = this.meetingChartVo.attendNewUserProportion

      // 签到用户数据概览
      this.signUserData[0].countConfig.endVal = this.meetingChartVo.signUserCount
      this.signUserData[1].countConfig.endVal = this.meetingChartVo.signUserProportion

      //  用户互动数据概览
      this.interactionUserData[0].countConfig.endVal = this.meetingChartVo.questionCount
      // this.interactionUserData[1].countConfig.endVal = this.meetingChartVo.fileViewCount
      // this.interactionUserData[2].countConfig.endVal = this.meetingChartVo.fileDownloadCount
      // this.interactionUserData[3].countConfig.endVal = this.meetingChartVo.shareMeetingCount
      // 嘉宾用户数据概览
      this.guestData[0].countConfig.endVal = this.meetingChartVo.guestCount
      this.guestData[1].countConfig.endVal = this.meetingChartVo.guestFileCount
      console.log(this.option2)
      this.$refs.chart.setOption(this.option2)
    },
  },
}
</script>

<style lang="less" scoped>
.layout {
  padding: 10px 20px;

  &_chidT {
    position: relative;
    margin-bottom: 10px;
    padding-left: 10px;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-top: 10px;
  }

  &_chidT::after {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background-color: #05a64c;
    top: 0;
    left: 0px;
  }
}

.order-card1-content {
  background: #f8f8f8;
  border-radius: 10px;
}
</style>
